import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ControlContainer, FormControl, FormGroupDirective, UntypedFormBuilder, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TimeApiService } from 'cbc-shared-lib';
import {
  AdconfirmTab, ClmtoInfo, CodeConversionMstDto,
  FinalConfirmTab, InspectionTreatmentTab, SafenoticeTab,
  Sgke361aResponse, ShishinInputTab, SupplyresumptionResultregistrationConsumptiondeviceinfo,
  SuppntInfo, TabArea, WorkResultArea
} from 'sg-api';
import { Sgke360dGuidingvalueInputComponent } from '../sgke360d-guidingvalue-input/sgke360d-guidingvalue-input.component';
import { Sgke360dInspectionTreatmentComponent } from '../sgke360d-inspection-treatment/sgke360d-inspection-treatment.component';
import { Sgke360dLastConfirmationComponent } from '../sgke360d-last-confirmation/sgke360d-last-confirmation.component';

@Component({
  selector: 'app-sgke360d-regist-area',
  templateUrl: './sgke360d-regist-area.component.html',
  styleUrl: './sgke360d-regist-area.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgke360dRegistAreaComponent implements OnInit, OnDestroy {

  /** 初期化APIの返り */
  @Input() initResponse: Sgke361aResponse;
  /** コード変換マスタマップ */
  @Input() codeMap: Map<string, CodeConversionMstDto[]> = null;

  @Output() onClickButtonEvent = new EventEmitter()

  /** モーダル表示状況エミッター */
  @Output() onModalIsDisplayEvent = new EventEmitter();

  @Output() drawFlgEvent = new EventEmitter<boolean>();

  /** 供給地点情報 */
  suppntInfo: SuppntInfo;
  /** 請求先情報 */
  clmtoInfo: ClmtoInfo;
  /** タブエリア */
  tabArea: TabArea;
  /** 作業結果エリア */
  workResultArea: WorkResultArea;
  /** 事前確認タブ */
  adconfirmTab: AdconfirmTab;
  /** 点検・処置タブ */
  inspectionTreatmentTab: InspectionTreatmentTab;
  /** 指針入力タブ */
  shishinInputTab: ShishinInputTab;
  /** 安全周知タブ */
  safenoticeTab: SafenoticeTab;
  /** 最終確認タブ */
  finalConfirmTab: FinalConfirmTab;

  /** 作業種別 */
  private sagyoshubetsuCD: string = '2';

  /** 点検・処置情報コンポーネント */
  @ViewChild(Sgke360dInspectionTreatmentComponent)
  public childComponent: Sgke360dInspectionTreatmentComponent;
  /** 指針入力情報コンポーネント */
  @ViewChild(Sgke360dGuidingvalueInputComponent)
  public shishinComponent: Sgke360dGuidingvalueInputComponent;
  /** 最終確認情報コンポーネント */
  @ViewChild(Sgke360dLastConfirmationComponent)
  public lastCofirmComponent: Sgke360dLastConfirmationComponent;

  private parentForm: UntypedFormGroup;
  /** 供給再開結果情報フォームグループ */
  private supplyresumptionResultInfoForm: UntypedFormGroup;
  private kykctnInfo: UntypedFormGroup;


  /** 転記円・処置タブ制御 */
  enabledInspectionTreatment: boolean = false;
  /** 指針入力タブ制御 */
  enabledGuidingvalueInput: boolean = false;
  /** 安全周知タブ制御 */
  enabledSafetyKnowledge: boolean = false;
  /** 最終確認タブ制御 */
  enabledLastConfirmation: boolean = false;

  /**
   *コンストラクタ
   * @param {ActivatedRoute} route
   * @param {TimeApiService} timeApiService
   * @param {FormGroupDirective} parent
   * @param {UntypedFormBuilder} fb
   * @memberof Sgke360dRegistAreaComponent
   */
  constructor(
    public timeApiService: TimeApiService,
    private parent: FormGroupDirective,
    private fb: UntypedFormBuilder,
  ) {
  }

  // 初期化処理
  ngOnInit(): void {
    this.suppntInfo = this.initResponse.initialhyojiInfo.basicInfoArea.suppntInfo;
    this.clmtoInfo = this.initResponse.initialhyojiInfo.basicInfoArea.clmtoInfo;
    this.tabArea = this.initResponse.initialhyojiInfo.tabArea;
    this.workResultArea = this.initResponse.initialhyojiInfo.workResultArea;
    this.adconfirmTab = this.tabArea.adconfirmTab;
    this.inspectionTreatmentTab = this.tabArea.inspectionTreatmentTab;
    this.shishinInputTab = this.tabArea.shishinInputTab;
    this.safenoticeTab = this.tabArea.safenoticeTab;
    this.finalConfirmTab = this.tabArea.finalConfirmTab;

    const mokushiinspectionNado = this.inspectionTreatmentTab.mokushiinspectionNado;
    const suspensionjiTreatment = this.inspectionTreatmentTab.suspensionjiTreatment;
    const dateValue = this.timeApiService.convertStringToDate;
    const timeValue = this.timeApiService.convertStringToTime;
    this.sagyoshubetsuCD = this.suppntInfo.workClscode;
    // 親フォーム
    this.parentForm = this.parent.form;
    // 非安全機器リスト件数
    const abnomalDevSize = this.safenoticeTab.safenoticeTargetConsumptiondevicelstarea?.length ?? 0;
    // 供給停止時メータガス栓閉止フラグ
    const meterGasssen = this.shishinInputTab.supplysuspensiontimeMetergassenFlg != '0';

    // 登録時必須判定関数
    const registCond = () => {
      return this.getControlvalue('supplystopresumptionResultDivcd') == '0';
    }

    // 供給再開結果情報フォーム
    this.supplyresumptionResultInfoForm = this.fb.group({
      //登録区分
      regDiv: [{ value: '1', disabled: false }, Validators.required],
      //作業種別コード
      workClscode: [{ value: this.suppntInfo.workClscode, disabled: false }],
      //エネルギー種別コード
      energyClscode: [{ value: this.suppntInfo.energyClscode, disabled: false }],
      //供給地点特定番号
      suppntSpno: [{ value: this.suppntInfo.suppntSpno, disabled: false }, Validators.required],
      //供給停止再開履歴番号
      supplystopresumptionRrkno:
        [{ value: this.suppntInfo.supplystopresumptionRrkno, disabled: false }, Validators.required],
      //供給停止再開地点情報管理_更新通番号
      supplystopresumptionPointinfomngUpdatesequencenumber:
        [{ value: this.initResponse.initialhyojiInfo.supplystopresumptionPointinfomngUpdatesequencenumber, disabled: false }, Validators.required],
      //供給停止再開作業種別コード
      supplystopresumptionWorkClscode:
        [{ value: this.suppntInfo.workClscode, disabled: false }, Validators.required],
      //請求先名
      visitName: [{ value: this.clmtoInfo.clmtoMeiKanji, disabled: false }],
      //作業場所コード
      workPlaceCode: [{ value: this.suppntInfo.workPlaceCode ?? '1', disabled: false }, this.requiredWith(registCond)],
      //供給停止再開結果区分コード
      supplystopresumptionResultDivcd:
        [{ value: this.workResultArea.supplystopresumptionResultDivcd, disabled: false }, Validators.required],
      //供給再開日付
      supplyresumptionDate: [{ value: dateValue(this.workResultArea.supplyresumptionDate), disabled: false },
      this.requiredWith((() => this.getControlvalue('supplystopresumptionResultDivcd') == '0'))],
      //供給再開時刻
      supplyresumptionHms: [{ value: timeValue(this.workResultArea.supplyresumptionHms), disabled: false },
      this.requiredWith((() => this.getControlvalue('supplystopresumptionResultDivcd') == '0'))],
      //供給再開作業担当者ユーザID
      supplyresumptionWorktntshUserid: [{ value: this.suppntInfo.supplyresumptionWorkchargeUserid, disabled: false }, Validators.required],
      //供給再開作業担当者名
      supplyresumptionWorkTantoshaname: [{ value: this.suppntInfo.supplyresumptionWorkTantoshaname, disabled: false }, Validators.required],
      //マイコンメーター有無フラグ
      microcontrollermeterUmuFlg: [{ value: this.adconfirmTab.microcontrollermeterUmuFlg, disabled: false }, Validators.required],
      //供給再開立会者区分コード
      supplyresumptionTaiperDivcd: [{ value: this.adconfirmTab.supplyresumptionTaiperDivcd, disabled: false }, Validators.required],
      //立会人周知不可フラグ
      witnessNotnoticeFlg: [{ value: this.adconfirmTab.witnessNotnoticeFlg, disabled: false }],
      //メーター外観異常フラグ
      meterExteriorAbnormalflag:
        [{ value: mokushiinspectionNado.meterExteriorAbnormalflag, disabled: false }, [this.isNg, Validators.required]],
      //メーターガス栓異常フラグ
      meterGassenAbnormalflag:
        [{ value: mokushiinspectionNado.meterGassenAbnormalflag, disabled: false }, [Validators.required, this.isNg(meterGasssen)]],
      //マイコンメーターテスト遮断異常フラグ
      microcontrollermeterTestblockAbnormalflag:
        [{ value: mokushiinspectionNado.microcontrollermeterTestblockAbnormalflag, disabled: false }, [Validators.required, this.isNg]],
      //マイコンメーター復帰異常フラグ
      microcontrollermeterReturnAbnormalflag:
        [{ value: mokushiinspectionNado.microcontrollermeterReturnAbnormalflag, disabled: false }, [Validators.required, this.isNg]],
      //動止確認漏洩検査可否フラグ
      operationcheckLeaktestKahiflg:
        [{ value: mokushiinspectionNado.operationcheckLeaktestKahiflg, disabled: false }, [Validators.required, this.isNg]],
      //メーター指針動止確認コード
      meterShishinstartandstopConfirmationcode:
        [{ value: mokushiinspectionNado.meterShishinstartandstopConfirmationcode, disabled: false }, Validators.required],
      //漏洩検査・圧力
      leaktestAtrk: [{ value: mokushiinspectionNado.leaktestAtrk, disabled: false }, Validators.required],
      //漏洩検査・時間
      leaktestTime: [{ value: mokushiinspectionNado.leaktestTime, disabled: false }, Validators.required],
      //漏洩検査・確認結果フラグ
      leaktestConfirmationresultFlg: [{ value: mokushiinspectionNado.leaktestConfirmationresultFlg, disabled: false }, Validators.required],
      //メーターガス栓閉止フラグ
      meterGassenShutoffflag: [{ value: suspensionjiTreatment.meterGassenShutoffflag, disabled: false }, Validators.required],
      //メーター休止措置フラグ
      meterPauseSochiflag: [{ value: suspensionjiTreatment.meterPauseSochiflag, disabled: false }, Validators.required],
      //点検業務引継先フラグ
      inspectiontaskTakeovertoFlg: [{ value: suspensionjiTreatment.inspectiontaskTakeovertoFlg, disabled: false }, Validators.required],
      //点検業務引継先コード
      inspectiontaskTakeovertoCode: [{ value: suspensionjiTreatment.inspectiontaskTakeovertoCode, disabled: true }, Validators.required],
      //再開時指針
      onresumptionShishin: [{ value: this.shishinInputTab.onresumptionShishin, disabled: false }, Validators.required],
      //再開時メーター番号
      onresumptionMeterNo: [{ value: this.shishinInputTab.onresumptionMeterNo, disabled: false }, Validators.required],
      //非安全機器周知フラグ
      unsafeDeviceNoticeflag: [{ value: this.safenoticeTab.unsafeDeviceNoticeflag, disabled: abnomalDevSize == 0 }, Validators.required],
      //点火試験済フラグ
      lightingExaminedFlg: [{ value: this.safenoticeTab.lightingExaminedFlg, disabled: false }, Validators.required],
      //チラシ投函フラグ
      flyerPostingFlg: [{ value: this.finalConfirmTab.flyerPostingFlg, disabled: false }, Validators.required],
      //署名
      signature: [{ value: null, disabled: false }],
      //署名区分
      signatureDiv: [{ value: this.finalConfirmTab.signatureDiv, disabled: false }, Validators.required],
      //作業者メモ
      sgyshMemo: [{ value: this.adconfirmTab.sgyshMemo, disabled: false }],

      //結果登録完了不可フラグ 指針入力画面より受取
      resultregistrationFinDisableflag: [{ value: this.shishinInputTab.resultregistrationFinDisableflag ?? null, disabled: false }, Validators.required],
      //メーター情報一致フラグ
      meterInfoIcchiflag: [{ value: this.shishinInputTab.meterInfoIcchiflag, disabled: false }, Validators.required],
      //メーター取替有無フラグ
      meterTorikaeEonflg: [{ value: this.shishinInputTab.meterTorikaeEonflg, disabled: false }, Validators.required],
      //取外メーター番号
      removalMeterNo: [{ value: this.shishinInputTab.removalMeterNo, disabled: false }, Validators.required],
      //取外時指針
      duringremovalShishin: [{ value: this.shishinInputTab.duringremovalShishin, disabled: false }, Validators.required],
      //取付メーター番号
      installationMeterNo: [{ value: this.shishinInputTab.installationMeterNo, disabled: false }, Validators.required],
      //取付時指針
      duringinstallationShishin: [{ value: this.shishinInputTab.duringinstallationShishin, disabled: false }, Validators.required],
      //メーター回転有無フラグ
      meterRotationEonflg: [{ value: this.shishinInputTab.meterRotationEonflg, disabled: false }, Validators.required],
      //供給停止年月日
      supplystopYearmonthdate: [{ value: dateValue(this.shishinInputTab.supplystopYearmonthdate), disabled: false }, Validators.required],
      //供給停止時刻
      supplystopHms: [{ value: this.shishinInputTab.supplystopHms, disabled: false }, Validators.required],
      //停止時指針
      duringstopShishin: [{ value: this.shishinInputTab.duringstopShishin, disabled: false }, Validators.required],
      //停止時使用量
      duringstopEmpamt: [{ value: this.shishinInputTab.duringstopEmpamt, disabled: false }, Validators.required],
      //マイコンメーター点滅フラグ
      microcontrollermeterFlashingFlg:
        [{ value: this.shishinInputTab.microcontrollermeterFlashingFlg, disabled: false }, Validators.required],
      //メーター休止フラグ
      meterPauseFlg: [{ value: this.shishinInputTab.meterPauseFlg, disabled: false }, Validators.required],
      //閉止不能理由コード
      shutoffFunoRsncod: [{ value: this.shishinInputTab.shutoffFunoRsncod, disabled: false }, Validators.required],
      //供給停止時処置フラグ
      supplysuspensiontimeTreatmentFlg:
        [{ value: this.shishinInputTab.supplysuspensiontimeTreatmentFlg, disabled: false }, Validators.required],
      //エフ取付フラグ
      efuInstallationFlg: [{ value: this.shishinInputTab.efuInstallationFlg, disabled: false }, Validators.required],
      //供給停止書投函場所コード
      supplystopdocumentPostingLocationcode:
        [{ value: this.shishinInputTab.supplystopdocumentPostingLocationcode, disabled: false }, Validators.required],
      //供給再開種別
      supplyresumptionClsfy: [{ value: this.shishinInputTab.supplyresumptionClsfy, disabled: false }, Validators.required],
      //変更前供給停止予定日付
      bfSupplystopScddt: [{ value: dateValue(this.shishinInputTab.bfSupplystopScddt), disabled: false }, Validators.required],
      //変更後供給停止予定日付
      afSupplystopScddt: [{ value: dateValue(this.shishinInputTab.afSupplystopScddt), disabled: false }, Validators.required],

      //変更前供給再開予定日付
      bfSupplyresumptionScddt:
        [{ value: dateValue(this.workResultArea.bfSupplyresumptionPlndate), disabled: false }],
      //変更後供給再開予定日付
      afSupplyresumptionScddt:
        [{ value: dateValue(this.workResultArea.afSupplyresumptionPlndate), disabled: false },
        this.requiredWith((() => this.getControlvalue('supplystopresumptionResultDivcd') == '1'))],
      //変更後供給再開予定時間帯
      afSupplyresumptionYtitimez:
        [{ value: this.workResultArea.afSupplyresumptionYtitimez, disabled: false },
        this.requiredWith((() => this.getControlvalue('supplystopresumptionResultDivcd') == '1'))],
    });
    this.parentForm.addControl('supplyresumptionResultInfo', this.supplyresumptionResultInfoForm);

    this.kykctnInfo = this.fb.group({
      // 請求お客さま番号
      recptFixNo: [{ value: this.clmtoInfo.payCtrNo, disabled: false }, Validators.required],
      // 契約お客さま番号
      firstSrvctrNo: [{ value: this.suppntInfo.firstSrvctrNo, disabled: false }, Validators.required],
      // サービス契約番号
      srvCtrNo: [{ value: this.suppntInfo.srvCtrNo, disabled: false }, Validators.required],
      // 使用お客さま番号
      logicDeviceNo: [{ value: this.suppntInfo.logicDeviceNo, disabled: false }, Validators.required],
      // 使用者お客さま氏名
      userVisitName: [{ value: this.suppntInfo.userMeiKanji, disabled: false }, Validators.required],
      // まとめ請求区分コード
      mtmclmDivcd: [{ value: this.clmtoInfo.mtmclmDivcd, disabled: false }, Validators.required],
      // メーター番号
      meterNo: [{ value: this.suppntInfo.meterNo, disabled: false }, Validators.required],
      // メーター型
      meterKata: [{ value: this.suppntInfo.meterKata, disabled: false }, Validators.required],
      // メーター能力
      meterAbility: [{ value: this.suppntInfo.meterAbility, disabled: false }, Validators.required],
      // メーター識別
      meterDiscrm: [{ value: this.suppntInfo.meterDiscrm, disabled: false }, Validators.required],
      // 総合区分コード
      sougouDivcd: [{ value: this.suppntInfo.sougouDivcd, disabled: false }, Validators.required],
      // 初期設定作業予定日付
      initialsetupWorkScddt: [{ value: this.suppntInfo.initialsetupWorkScddt, disabled: false }, Validators.required],
      // 作業中断初回登録時刻
      worksuspensionFirstRegistrationtime: [{ value: this.suppntInfo.worksuspensionFirstRegistrationtime, disabled: false }, Validators.required],
      // 使用場所住所
      empposAddr: [{ value: this.suppntInfo.empposAddr, disabled: false }, Validators.required],
      // 総合供給先番号
      sougouSupplydestinationNo: [{ value: this.suppntInfo.sougouSupplydestinationNo, disabled: false }, Validators.required],
      // 督促料金番号
      pressChargenumber: [{ value: this.suppntInfo.pressChargenumber, disabled: false }, Validators.required],
      // 供給停止強制有無フラグ
      supplystopForceEonflg: [{ value: this.suppntInfo.supplystopForceEonflg, disabled: false }, Validators.required],
      // 供給停止作業担当ユーザID
      supplystopWorkchargeUserid: [{ value: this.shishinInputTab.supplystopWorkchargeUserid, disabled: false }, Validators.required],
      // 供給停止作業担当者名
      supplystopWorkTantoshaname: [{ value: this.shishinInputTab.supplystopWorkTantoshaname, disabled: false }, Validators.required],
    });
    this.parentForm.addControl('supplystopresumptionPointinfomngInfo', this.kykctnInfo);

    // 供給再開結果登録消費機器情報リスト
    const consumptiondevice = this.safenoticeTab.safenoticeTargetConsumptiondevicelstarea?.map((row) => {
      return this.fb.group({
        consumptiondeviceNo: row.consumptiondeviceNo,
        setsubiNo: row.setsubiNo,
        consumptiondeviceModel: row.consumptiondeviceModelCode,
        consumptiondeviceModelname: row.consumptiondeviceModelname,
        manufactureYm: row.manufactureYm,
        ventilationHoshiki: row.ventilationHoshikiCode,
        ventilationHoshikiMei: row.ventilationHoshikiMei,
        cnnctJokyo: row.cnnctJokyoCode,
        cnnctJokyoMei: row.cnnctJokyoMei,
        saleKeitai: row.salfrmCode,
        saleKeitaiMei: row.saleKeitaiMei,
        manufacturer: row.manufacturercode,
        manufacturerMei: row.manufacturerMei,
        model: row.model,
        installationPlace: row.installationlocationCode,
        installationlocationMei: row.installationlocationMei,
        nonconformityCode: row.nonconformityCode,
        nonconformityCont: row.nonconformityCont,
        covalue: row.covalueCode,
        covalueMei: row.covalueMei,
      } as SupplyresumptionResultregistrationConsumptiondeviceinfo);
    }) ?? [];
    this.parentForm.addControl('supplyresumptionResultregistrationConsumptiondeviceinfoList',
      this.fb.array(consumptiondevice));
  }
  /**
   * 終了処理
   *
   * @memberof Sgke360dRegistAreaComponent
   */
  ngOnDestroy(): void {
    this.supplyresumptionResultInfoForm.clearValidators();
    this.supplyresumptionResultInfoForm.updateValueAndValidity();
  }

  /**
   * タブの状態更新
   *
   * @memberof Sgke360dRegistAreaComponent
   */
  tabUpdate() {
    if (this.sagyoshubetsuCD == '2') {
      /** 一般供給再開 */
      this.enabledInspectionTreatment = true;
      this.enabledGuidingvalueInput = true;
      this.enabledSafetyKnowledge = true;
      this.enabledLastConfirmation = true;
      this.childComponent?.onChangeCheck();
    } else {
      /** 簡易供給再開 */
      //安全周知タブは常に非表示
      this.enabledSafetyKnowledge = false;

      // 作業場所
      const workPlace = this.getControlvalue('workPlaceCode');
      // マイコンメーター有無
      const micon = this.getControlvalue('microcontrollermeterUmuFlg');

      if (workPlace == '2') {
        // 作業場所＝遠隔が選択された場合、指針入力タブのみ有効
        this.enabledInspectionTreatment = false;
        this.enabledGuidingvalueInput = true;
        this.enabledLastConfirmation = false;

      } else if (workPlace == '1') {
        if (micon == '0') {
          //マイコンメータなしの場合、点検・処置タブ、無効、最終確認タブ有効
          this.enabledInspectionTreatment = false;
          this.enabledGuidingvalueInput = false;
          this.enabledLastConfirmation = true;
        } else if (micon == '1') {
          //マイコンメータありの場合、点検・処置タブ、指針入力タブ無効、最終確認タブ有効
          this.enabledInspectionTreatment = true;
          this.enabledGuidingvalueInput = true;
          this.enabledLastConfirmation = true;
        } else {
          //マイコンメータ未選択の場合、点検・処置タブ、指針入力タブ、最終確認タブ無効
          this.enabledInspectionTreatment = false;
          this.enabledGuidingvalueInput = false;
          this.enabledLastConfirmation = false;
        }
      }
    };
  }

  /**
   * 異常有無バリデータ
   *
   * @param [enable=true] チェック有効条件
   * @return {*}  {ValidatorFn} バリデーション関数
   * @memberof Sgke360dInspectionTreatmentComponent
   */
  private isNg(enable:boolean = true): ValidatorFn {
    return (control: FormControl): { [key: string]: any } => {
      // チェック無効の場合はOKを返す
      if (!enable) {
        return null;
      }
      // 値を取得
      let val: string = control.value;
      // '0'(異常無)の場合のみOK。それ以外はNG。
      return val == '0' ? null : { 'isNg': true };
    }
  }
  /**
   * 条件付き必須バリデータ
   *
   * @private
   * @param {() => boolean} func 必須条件関数
   * @return {*}  {ValidatorFn}
   * @memberof Sgke360dRegistAreaComponent
   */
  private requiredWith(func: () => boolean): ValidatorFn {
    return (control: FormControl): { [key: string]: any } => {
      return func() ? Validators.required(control) : null;
    }
  }

  /**
   * フォームコントロール取得
   * @param ctlname コントロール名
   * @returns フォームコントロール
   */
  private getControlvalue(ctlname: string): any {
    return this.supplyresumptionResultInfoForm?.get(ctlname)?.value;
  }

}
